var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientHeartIcon = function SvgPatientHeartIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_790_1481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6429 4.39046C10.6429 6.37343 9.03536 7.98094 7.05239 7.98094C5.06943 7.98094 3.46191 6.37343 3.46191 4.39046C3.46191 2.4075 5.06943 0.799988 7.05239 0.799988C9.03536 0.799988 10.6429 2.4075 10.6429 4.39046ZM13.4047 12.1238C13.4047 14.1067 10.5607 15.7142 7.05233 15.7142C3.54401 15.7142 0.699951 14.1067 0.699951 12.1238C0.699951 10.1408 3.54401 8.53329 7.05233 8.53329C10.5607 8.53329 13.4047 10.1408 13.4047 12.1238ZM8.01016 11.1047C8.31173 10.7879 8.80067 10.7879 9.10224 11.1047L9.57237 11.5685C9.6141 11.6097 9.68245 11.6097 9.72418 11.5685L10.1943 11.1047C10.4959 10.7879 10.9848 10.7879 11.2864 11.1047C11.5879 11.4214 11.5879 11.935 11.2864 12.2517L9.84378 13.7669C9.73836 13.8776 9.5582 13.8776 9.45277 13.7669L8.01016 12.2517C7.70859 11.935 7.70859 11.4214 8.01016 11.1047Z",
    fill: "#313336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_790_1481",
    x: -8.24862,
    y: -8.14858,
    width: 30.6019,
    height: 32.8114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 4.47429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_790_1481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_790_1481",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientHeartIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "patient-heart-icon.d37f0e00fbdd93895e208483ca58b510.svg";